var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout-simple',{attrs:{"title":_vm.$t('views.Error.title')}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('error-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }